import { render } from "./Office.vue?vue&type=template&id=11e2f8bc&scoped=true"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"

import "./Office.vue?vue&type=style&index=0&id=11e2f8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e2f8bc"]])

export default __exports__